import {ApolloLink} from "apollo-link"
import {getGraphError} from "../../API/utils/errorHandler/getGraphError"

/**
 * Error marshalling
 * this shouldn't be done in this way, instead we should probably move this
 * into the .extensions field
 *
 * keeping for now to keep compatibility with
 * existing code
 */
export const apolloErrorHandlerLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((res) => {
    if (res.errors) {
      throw getGraphError(res.errors, operation.operationName)
    } else return res
  })
})
